import Constant from './constant';

export const setPreview = payload => {
  return {
    type: Constant.SET,
    payload,
  };
};
